<template>
  <div class="formGroup" :data-layout="layout">
    <div class="formGroup__body">
      <formLabel :label="label" :validation="validation"></formLabel>
      <input
        ref="input"
        class="formControl"
        data-fixed-font="true"
        :data-error="errors.has(name)"
        type="tel"
        maxlength="19"
        :placeholder="placeholder"
        @keyup="update($event)"
        @blur="update($event)"
      >
      <input
        type="text"
        v-show="false"
        v-validate:formattedValue="validation"
        :name="name"
        :value="formattedValue"
      >
    </div>
    <div class="formGroup__footer">
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Formatter from 'formatter.js-pebble'
import mixin from './mixin'

export default {
  name: 'form-credit-card',
  mixins: [mixin],
  props: {
    type: { type: String, default: 'text' }
  },
  data: () => ({
    formattedValue: ''
  }),
  mounted() {
    new Formatter(this.$refs.input, {
      pattern: '{{9999}} {{9999}} {{9999}} {{9999}}',
      change: true
    })
  },
  methods: {
    update($event) {
      this.formattedValue = $event.target.value.replace(/ /g, '')
      this.$emit('input', this.formattedValue)
      this.$emit('change', this.formattedValue)
    },
    resetErrors() {
      this.formattedValue = ''
      document.querySelector(".formGroup[data-vv-name='cc_number'] .formControl").value = ''
      this.$emit('input', this.formattedValue)
      this.$emit('change', this.formattedValue)
      this.errors.clear()
    }
  }
}</script>

<style lang="scss" scoped>
.formControl {
  &[data-fixed-font='true'] {
    font-family: monospace;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormCreditCard.vue